/**
 * reference for holding the looked up dom element, so that a
 * dom lookup is not required every time a reference to this element is needed.
 */
let mobileNavRef;

export const getMobileNavElement = () => {
  if (typeof window !== "undefined") {
    mobileNavRef = !mobileNavRef
      ? document.querySelector('[data-testid="nav-mobile"]')
      : mobileNavRef;
  }
  return mobileNavRef;
};

export const isMobileNavOpen = () =>
  !!getMobileNavElement() &&
  getComputedStyle(getMobileNavElement())?.top === "0px";

export const isElementAtTopOfMobileViewPort = (elem) => {
  const mobileNav = getMobileNavElement();
  const navHeight = mobileNav
    ? parseInt(getComputedStyle(mobileNav).height, 10)
    : 0;
  const { top } = elem.getBoundingClientRect();
  return isMobileNavOpen()
    ? top > navHeight - 1 && top < navHeight + 1
    : top >= 0 && top <= 20;
};

// TODO: improve the implementation of isElementHidden()
/**
 * Utility method to check if a html element is visible on the screen
 * NB: this does not factor in elements hidden by offset/scrolling,
 * just those hidden by opacity, visibility, display css props and zero height/width.
 * It tests visibility of the element, then that of each enclosing parent element
 * until it gets to the element with selector matching `parentSelector`
 * This is not a very efficient algorithm, so use sparingly. Thanks!
 * @param {HTMLElement} elem - element whose visibility is being tested
 * @param {string} parentSelector - selector of element within which the traversal happens
 * @returns {boolean}
 */
export const isElementHidden = (elem, parentSelector = "#app") => {
  if (!elem) return true;
  const outermostParent = document.querySelector(parentSelector);
  const visibilityAttributes = {
    height: "0",
    width: "0",
    opacity: "0",
    display: "none",
    visibility: "hidden"
  };
  function isVisible(node) {
    let visible = true;
    Object.keys(visibilityAttributes).every((key) => {
      const style = getComputedStyle(node);
      if (
        style?.[key] === visibilityAttributes[key] ||
        `${parseInt(style?.[key], 10)}` === visibilityAttributes[key]
      ) {
        visible = false;
        return false; // break out of loop if node is hidden
      }
      return true; // continue loop if node is visible
    });
    return visible;
  }
  let isHidden = !isVisible(elem);
  if (isHidden) return true;
  if (!outermostParent) return isHidden;
  let parent = elem;
  while (parent && parent !== outermostParent) {
    parent = parent?.parentElement;
    if (!isVisible(parent)) {
      isHidden = true;
      break;
    }
    // ultimately exit the loop if traversal gets to body
    if (parent?.nodeName === "BODY") break;
  }
  return isHidden;
};
